import { Box } from "@mui/material";
import { Button, InputNumber, Select, Space } from "antd";

import { HOLIDAY_DIFFERENTIAL, HOLIDAY_FEE_TYPE_OPTIONS } from "./constants";
import { type HolidayIncrement } from "./types";

export interface QualificationOption {
  value: string;
  label: string;
}

export interface AddHolidayFeeFormProps {
  qualificationOptions: QualificationOption[];
  newQualifications: string[];
  newType: HolidayIncrement | undefined;
  newIncrement: number | undefined;
  isUpdating: boolean;
  onQualificationsChange: (qualifications: string[]) => void;
  onTypeChange: (type: HolidayIncrement | undefined) => void;
  onIncrementChange: (increment: number | undefined) => void;
  onSave: () => void;
  onCancel: () => void;
}

export function AddHolidayFeeForm(props: AddHolidayFeeFormProps): JSX.Element {
  const {
    qualificationOptions,
    newQualifications,
    newType,
    newIncrement,
    isUpdating,
    onQualificationsChange,
    onTypeChange,
    onIncrementChange,
    onSave,
    onCancel,
  } = props;

  return (
    <Box sx={{ marginTop: 2, padding: 2, backgroundColor: "grey.100", borderRadius: 1 }}>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Space wrap>
          <Select
            showSearch
            mode="multiple"
            options={qualificationOptions}
            placeholder="Select Qualifications"
            style={{ minWidth: 200 }}
            value={newQualifications}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            onChange={onQualificationsChange}
          />
          <Select
            options={HOLIDAY_FEE_TYPE_OPTIONS}
            placeholder="Select Type"
            style={{ width: 140 }}
            value={newType}
            onChange={onTypeChange}
          />
          {newType === HOLIDAY_DIFFERENTIAL.FLAT && (
            <InputNumber
              addonAfter="/hr"
              addonBefore="$"
              min={0}
              placeholder="Amount"
              precision={2}
              value={newIncrement}
              onChange={(value) => {
                onIncrementChange(value ?? undefined);
              }}
            />
          )}
          {newType === HOLIDAY_DIFFERENTIAL.CHARGE_RATE_MULTIPLIER && (
            <InputNumber
              addonAfter="x"
              min={1}
              placeholder="Multiplier"
              precision={2}
              step={0.1}
              value={newIncrement}
              onChange={(value) => {
                onIncrementChange(value ?? undefined);
              }}
            />
          )}
        </Space>
        <Space>
          <Button loading={isUpdating} type="primary" onClick={onSave}>
            Save
          </Button>
          <Button disabled={isUpdating} onClick={onCancel}>
            Cancel
          </Button>
        </Space>
      </Space>
    </Box>
  );
}
